// Copyright 2025, Imprivata, Inc.  All rights reserved.

import type React from 'react';
import { Spin } from 'antd';
import { ImprChip } from '@imprivata-cloud/components';

import './ItemList.less';

export interface ListItemProps {
  name: string;
  upn: string;
  isAdmin?: boolean;
  'data-testid'?: string;
  className?: string;
  rowMenu?: React.ReactNode;
  isLoading?: boolean;
}

const ItemList = (props: ListItemProps) => {
  return (
    <div className={'list-item-container'} data-testid={'list-item'}>
      {props.isLoading ? (
        <div className="list-item-spinner">
          <Spin />
        </div>
      ) : (
        <>
          <div className="list-item-main-block">
            <div className="list-item-left">
              <div data-testid="list-item-primary-text" className="list-item-primary-text">
                {props.name}
              </div>
              {props.upn ? (
                <div data-testid="list-item-secondary-text" className="list-item-secondary-text">
                  {props.upn}
                </div>
              ) : null}
            </div>
            <div>{props.isAdmin && <ImprChip label={'Admin'} className="admin-chip" />}</div>
          </div>

          <div className="list-item-right">{props.rowMenu ?? null}</div>
        </>
      )}
    </div>
  );
};

export default ItemList;
